import styled from 'styled-components';
import { Select, Input } from 'antd';

export const AddsContainer = styled.div`
  margin-top: 10px;
`;

export const StyledSelect = styled(Select)`
  & .ant-select-selector {
    border: 1px solid white !important; /* Set default border to white */
    box-shadow: none !important; /* Remove any default box-shadow */
    border-radius: 4px; /* Ensure border-radius matches hover state */
  }

  /* Hover state for the entire Select component */
  &:hover {
    outline: 1px solid #d9d9d9; /* Outline on hover */
    border-radius: 4px; /* Match border-radius */
  }

  /* Ensure the selector's border doesn't override the hover outline */
  &:hover .ant-select-selector {
    border: 1px solid white !important; /* Keep the white border on hover */
  }

  /* Focus state (optional, to maintain consistency) */
  &.ant-select-focused .ant-select-selector {
    border: 1px solid white !important; /* Keep white border on focus */
    box-shadow: none !important; /* Remove default focus shadow */
  }

  /* Handle disabled state */
  &.ant-select-disabled .ant-select-selector {
    border: 1px solid white !important; /* Keep white border in disabled state */
    background: #f5f5f5; /* Ant Design's default disabled background */
  }
`;

export const Container = styled.div`
  marging: 10px;
`;

export const StyledInput = styled(Input)`
  /* Target the input element itself */
  .ant-input {
    background: transparent; /* Optional: Remove background if needed */
    transition: border 0.3s ease; /* Smooth transition for border changes */

    /* Add border on hover */
    &:hover {
      box-shadow: none;
    }

    /* Add border on focus */
    &:focus {
      border: none;
      box-shadow: none; /* Override Ant Design's default focus shadow */
    }
  }

  /* If the input has a prefix/suffix, target the wrapper */
  &.ant-input-affix-wrapper {
    border: 1px solid #d9d9d9;
    box-shadow: none;

    padding-left: 1px;
    padding-right: 1px;

    &:hover {
      border: 1px solid #d9d9d9;
    }

    &.ant-input-affix-wrapper-focused {
      border: 1px solid #d9d9d9;
      box-shadow: none;
    }

    .ant-input-prefix {
      margin: 0px;
    }
  }

  /* Optional: Handle disabled state */
  &.ant-input-disabled,
  &.ant-input-affix-wrapper-disabled {
    border: none; /* Ensure no border in disabled state */
    background: #f5f5f5; /* Ant Design's default disabled background */
  }
`;
